import React from 'react'
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom'
import SimpleReactLightbox from 'simple-react-lightbox'

// import { CareerHistoryPage } from 'components/pages/careerHistoryPage/CareerHistoryPage'
import { HomePage } from 'components/pages/homePage/HomePage'
import { AboutPage } from 'components/pages/aboutPage/AboutPage'
import SkillsPage from 'components/pages/skillsPage/SkillsPage'
import PortfolioPage from 'components/pages/portfolio/portfolioPage/PortfolioPage'
import BlogHomePage from 'components/pages/blog/BlogHomePage'
import { CipherPage } from 'components/pages/cipherPage/CipherPage'

// import LabsPage from 'components/pages/labs/labsPage/LabsPage';
import { NotFoundPage } from 'components/pages/notFoundPage/NotFoundPage'
import { CookiesPolicy } from 'components/shared/cookies/cookiePolicy/CookiePolicy'
import { PortfolioSkeletonPage } from 'components/pages/portfolio/portfolioSkeletonPage/PortfolioSkeletonPage'
import { CookiesNotification } from 'components/shared/cookies/cookiesNotification/CookiesNotification'
import ContactModal from 'components/shared/Modals/ContactModal/ContactModal'
import { BlogSkeletonPage } from 'components/pages/blog/blogSkeletonPage/BlogSkeletonPage'

// Import Data for Portfolio
import { onXmapsData } from 'components/pages/portfolio/portfolioSkeletonPage/projectsData/onXmapsData'
import { huntinggpsmapsData } from 'components/pages/portfolio/portfolioSkeletonPage/projectsData/huntinggpsmapsData'
import { roamData } from 'components/pages/portfolio/portfolioSkeletonPage/projectsData/roamData'
import { onXmapsReportingData } from 'components/pages/portfolio/portfolioSkeletonPage/projectsData/onXmapsReportingData'
import { acclarisData } from 'components/pages/portfolio/portfolioSkeletonPage/projectsData/acclaris1.5Data'
import { whereToBuyData } from 'components/pages/portfolio/portfolioSkeletonPage/projectsData/whereToBuyData'
import { masoniteData } from 'components/pages/portfolio/portfolioSkeletonPage/projectsData/masoniteData'

// Import Data for Blog
import { managingExpectationsData } from 'components/pages/blog/blogData/managingExpectationsData'
import { accountabilityData } from 'components/pages/blog/blogData/accountabilityData'
import { buildingYourBrandData } from 'components/pages/blog/blogData/buildingYourBrandData'
import { designingSystemsForTheTeamData } from 'components/pages/blog/blogData/designingSystemsForTheTeamData'
import { workingEfficientlyData } from 'components/pages/blog/blogData/workingEfficientlyData'
import { earningFavorData } from 'components/pages/blog/blogData/earningFavorData'

// import ShoppingHelperPage from './../components/MortgageCalculatorPage/ShoppingHelper/ShoppingHelperPage';
import Header from 'components/shared/header/Header'

const AppRouter = () => {
    const blogs = [
        managingExpectationsData,
        accountabilityData,
        buildingYourBrandData,
        designingSystemsForTheTeamData,
        workingEfficientlyData,
        earningFavorData,
    ]

    return (
        <Router>
            <div>
                <SimpleReactLightbox>
                    <ContactModal />
                    <CookiesNotification />
                    <Header />
                    <Switch>
                        <Route path="/" component={HomePage} exact={true} />
                        <Route path="/about" component={AboutPage} />
                        <Route path="/skills" component={SkillsPage} />
                        <Route
                            path="/portfolio"
                            component={PortfolioPage}
                            exact={true}
                        />
                        <Route
                            path="/portfolio/onxmaps"
                            component={() => (
                                <PortfolioSkeletonPage
                                    portfolioData={onXmapsData}
                                />
                            )}
                            exact={true}
                        />

                        <Route
                            path="/portfolio/hunting-gps-maps"
                            component={() => (
                                <PortfolioSkeletonPage
                                    portfolioData={huntinggpsmapsData}
                                />
                            )}
                            exact={true}
                        />
                        <Route
                            path="/portfolio/roam-gps-maps"
                            component={() => (
                                <PortfolioSkeletonPage
                                    portfolioData={roamData}
                                />
                            )}
                            exact={true}
                        />
                        <Route
                            path="/portfolio/onxmaps-reporting-tool"
                            component={() => (
                                <PortfolioSkeletonPage
                                    portfolioData={onXmapsReportingData}
                                />
                            )}
                            exact={true}
                        />
                        {/*<Route path='/labs/shopping-helper' component={ ShoppingHelperPage } />*/}
                        <Route
                            path="/portfolio/acclaris"
                            component={() => (
                                <PortfolioSkeletonPage
                                    portfolioData={acclarisData}
                                />
                            )}
                            exact={true}
                        />
                        <Route
                            path="/portfolio/where-to-buy"
                            component={() => (
                                <PortfolioSkeletonPage
                                    portfolioData={whereToBuyData}
                                />
                            )}
                            exact={true}
                        />
                        <Route
                            path="/portfolio/masonite"
                            component={() => (
                                <PortfolioSkeletonPage
                                    portfolioData={masoniteData}
                                />
                            )}
                            exact={true}
                        />
                        <Route
                            path="/cookie-policy"
                            component={() => <CookiesPolicy />}
                            exact={true}
                        />

                        <Route
                            path="/blog"
                            component={() => <BlogHomePage />}
                            exact={true}
                        />

                        <Route
                            path="/cipher"
                            component={() => <CipherPage />}
                            exact={true}
                        />

                        {/*<Route path="/career-history" component={CareerHistoryPage} />*/}

                        {/*Blog Routing Pages*/}

                        {blogs.map((blog, index) => {
                            return (
                                <Route
                                    path={blog.webLink}
                                    component={() => (
                                        <BlogSkeletonPage blogData={blog} />
                                    )}
                                    exact={true}
                                    key={index}
                                />
                            )
                        })}

                        {/*<Route path='/labs' component={ LabsPage } />*/}
                        <Route component={NotFoundPage} />
                    </Switch>
                </SimpleReactLightbox>
            </div>
        </Router>
    )
}

export { AppRouter }
